<template>
<div class="thumbnail" v-bind:style="value != '' && [{'background-image':'url('+value+')'}, {'background-size': 'cover'}]" @mouseover="mouseover = true" @mouseleave="mouseover = false">
    <span v-show="value == ''" style="font-size:30px;cursor: pointer;" @click="onChangeClick">
        <span class="file-preview"><span style="position: absolute; inset: 0px;">
                <svg class="vue-file-agentN" viewBox="0 0 1000 1000">
                    <path d="M745,353c-5.6,0-11.3,0.2-17.2,0.7C687.4,237.3,577.8,157,451,157c-162.1,0-294,131.9-294,294c0,2.1,0,4.1,0,6.2C72.6,479,10,555.8,10,647c0,108.1,87.9,196,196,196h245V618.3l-63.4,63.4c-9.6,9.6-22.1,14.4-34.6,14.4s-25.1-4.8-34.6-14.4c-19.2-19.2-19.2-50.1,0-69.3l147-147c4.6-4.6,9.9-8.1,16-10.6c12-4.9,25.5-4.9,37.4,0c6,2.5,11.4,6.1,16,10.6l147,147c19.2,19.2,19.2,50.1,0,69.3c-9.6,9.6-22.1,14.4-34.6,14.4s-25.1-4.8-34.6-14.4L549,618.3V843h196c135.1,0,245-109.9,245-245S880.1,353,745,353z"></path>
                </svg>
                <span class="help-text">이미지 추가</span>
            </span>
        </span>
    </span>
    <input type="file" ref="fileInput" style="display:none;" accept="image/jpeg, image/png" @change="onUploadFiles" />
    <div v-show="value != '' && mouseover" class="maskbg"></div>
    <button type="button" v-show="value != '' && mouseover" class="btn btn-close" @click="onRemove">
        <b-icon-trash></b-icon-trash>
    </button>
    <button type="button" v-show="value != ''" class="btn btn-download" @click="onDownloadClick">
        <b-icon-download></b-icon-download>
    </button>
    <button type="button" v-show="value != ''" class="btn btn-preview" @click="onPreviewClick">
        <b-icon-search></b-icon-search>
    </button>
</div>
</template>

<script>
import {
    ContainerClient
} from '@azure/storage-blob';
import {
    getfilename,
    reqPost
} from "../../constants/request";
import axios from 'axios'
import Compressor from "compressorjs";
import {
    mapGetters,
    mapActions,
    mapMutations,
    Store
} from "vuex";
import api from "../../constants/api";
export default {
    components: {},
    model: {
        prop: 'value',
    },
    props: {
        value: {
            type: String,
            required: true,
            default: "",
        },
        index: {
            type: Number,
            default: 0,
        },
        change: {
            type: Function,
            default: () => {},
        },
        downlabel: {
            type: String,
            // required: true,
            default: "",
        },
    },
    data() {
        return {
            fileInput: null,
            mouseover: false,
            imgwidth: 0,
            imgheight: 0,
        };
    },
    computed: {
        ...mapGetters(['currentUser', 'siteName', 'goodsTypeOption', 'goodsType', 'goodsName', 'goodsTag', 'intro', 'mainImage', 'subImages', 'storeCodes']),
    },
    watch: {},
    mounted() {},
    methods: {
        getAdminsas() {
            const vm = this;
            let reqURL = api.changeAPI(vm.siteName, api.basicURL + api.user.azureSas);
            let params = {
                type: 'STORE'
            }
            vm.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${vm.currentUser.tokens.access.token}`
                }
            }).then(res => {
                this.url = res.data.data.url;
                this.container = res.data.data.container;
                this.directory = res.data.data.directory;
                this.expiresIn = res.data.data.expiresIn;
            }).catch(err => {
                alert("이미지 파일을 업로드하지 못하였습니다.")
            });
        },
        onChangeClick() {
            this.$refs.fileInput.click();
        },
        compressImage(imageFile) {
            return new Promise((resolve, reject) => {
                new Compressor(imageFile, {
                    maxWidth: 600,
                    quality: 0.8,
                    success(result) {
                        resolve(result)
                    },
                    error(e) {
                        reject(e)
                    },
                });
            });
        },
        onUploadFiles(event, drag) {
            let imageFile = '';
            if (drag) {
                imageFile = event;
            } else {
                imageFile = event.target.files[0];
            }

            this.compressImage(imageFile).then((compressedFile) => {
                let reader = new FileReader();
                reader.readAsDataURL(compressedFile);
                reader.onload = evt => {
                    let img = new Image();
                    img.onload = () => {
                        this.imgwidth = img.width;
                        this.imgheight = img.height;
                    }
                    img.src = evt.target.result;
                }

                reader.onerror = evt => {
                    console.error(evt);
                }

                if (this.value === '') {
                    this.onRegisterImage(compressedFile);
                } else {
                    this.onChangeImage(compressedFile);
                }
            }).catch((error) => {
                alert("이미지 리사이징 에러입니다.");
            });
            //input 요소의 value 값을 ''으로 초기화해주면, 같은 파일을 재 업로드할 경우에도 change 이벤트가 정상적으로 발생되어서 재 업로드가 가능
            this.$refs.fileInput.value = ''
        },
        onRegisterImage(imageFile) {
            const vm = this;
            let reqURL = api.changeAPI(vm.siteName, api.basicURL + api.user.azureSas);
            let params = {
                type: 'STORE'
            }
            vm.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${vm.currentUser.tokens.access.token}`
                }
            }).then(res => {
                const containerClient = new ContainerClient(res.data.data.url);
                var d = new Date();
                var n = d.getTime();
                let filename = n + '_' + imageFile.name;
                const blockBlobClient = containerClient.getBlockBlobClient(res.data.data.directory + "/" + filename);
                blockBlobClient.uploadBrowserData(imageFile, {
                    blockSize: 40 * 1024 * 1024, // 파일 사이즈 제한
                    blobHTTPHeaders: {
                        blobContentType: imageFile.type
                    },
                }).then((upfile) => {
                    var r_url = upfile._response.request.url;
                    let uploadedUrl = r_url.substring(0, r_url.indexOf("?sig="));
                    this.$emit('input', uploadedUrl);
                    this.change(this.index, uploadedUrl, this.imgwidth, this.imgheight);
                });
            }).catch(err => {
                alert("이미지 파일을 업로드하지 못하였습니다.")
            });

        },
        onPreviewClick() {
            console.log(this.value)
            this.windowRef = window.open(this.value, "", "width=600,height=400,left=200,top=200");
            this.windowRef.addEventListener('beforeunload', this.closePortal);
        },
        closePortal() {
            if (this.windowRef) {
                this.windowRef.close();
                this.windowRef = null;
            }
        },
        onChangeImage(imageFile) {
            const vm = this;
            let reqURL = api.changeAPI(vm.siteName, api.basicURL + api.user.azureSas);
            let params = {
                type: 'STORE'
            }
            vm.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${vm.currentUser.tokens.access.token}`
                }
            }).then(res => {
                const containerClient = new ContainerClient(res.data.data.url);
                var d = new Date();
                var n = d.getTime();
                let filename = n + '_' + imageFile.name;
                const blockBlobClient = containerClient.getBlockBlobClient(res.data.data.directory + "/" + filename);
                blockBlobClient.uploadBrowserData(imageFile, {
                    blockSize: 40 * 1024 * 1024, // 파일 사이즈 제한
                    blobHTTPHeaders: {
                        blobContentType: imageFile.type
                    },
                }).then((upfile) => {
                    var r_url = upfile._response.request.url;
                    let uploadedUrl = r_url.substring(0, r_url.indexOf("?sig="));
                    this.$emit('input', uploadedUrl);
                    console.log(this.index)
                    this.change(this.index, uploadedUrl, this.imgwidth, this.imgheight);
                });
            }).catch(err => {
                alert("이미지 파일을 업로드하지 못하였습니다.")
                // reject(new Error('업로드 실패'));
            });

        },
        onDownloadClick() {
            axios.get(this.value, {
                    responseType: 'blob'
                })
                .then(response => {
                    const blob = new Blob([response.data], {
                        type: 'application/pdf'
                    })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    if (this.downlabel == "") {
                        link.download = getfilename(this.value);
                    } else {
                        link.download = this.downlabel;
                    }
                    link.click()
                    URL.revokeObjectURL(link.href)
                }).catch(console.error)
        },
        onRemove() {
            this.$emit('input', "");
            this.change(this.index, "", 0, 0);
        }
    },
};
</script>

<style scoped>
.vue-file-agentN {
    fill: #aaa;
    /* margin-top: 16%; */
    height: 36%;
    display: block;
    position: absolute;
    bottom: 68px;
}

.help-text {
    color: #aaa;
    text-align: center;
    font-size: 16px;
    /* line-height: 20px; */
    height: 20px;
    display: block;
    position: relative;
    top: 17px;
}

.thumbnail {
    width: 156px;
    height: 156px;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin: 0;
    cursor: pointer;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    position: relative;
    padding: 0px;
    background-color: #E8E8E8;
}

.thumbnail span {
    padding: 0px;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.maskbg {
    position: absolute;
    left: 0px;
    top: 0px;
    height: 100%;
    width: 100%;
    background-color: #00000070;
}

.btn {
    position: absolute;
    background-color: #FFFFFFA0;
    border-radius: 100px;
    padding: 6px;
    height: 32px;
}

.btn-close {
    top: 0px;
    right: 0px;
}

.btn-preview {
    left: 0px;
    bottom: 0px;
}

.btn-download {
    right: 0px;
    bottom: 0px;
}
</style>
